define('drops/businessProcessCanvas/businessProcessCanvas',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/dropFactory',
    'drops/drawings/businessprocessEvents',
    'drops/drawings/runtimeTypesProvider',
    'lq/onlongpress',
    'html2canvas',
    'when'
],
function (
    $,
    Drop,
    Style,
    util,
    DropFactory,
    businessProcessEvents,
    runtimeTypesProvider,
    OnLongPress,
    html2canvas,
    when) {
    'use strict';

    var defaults = {
        data: {
            text: 'Guid',
            longPressDelay: 1000
        }
    };

    function BusinessProcessCanvas(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        var self = this;

        self.rootDrop = this;
        self.drawingDropFactory = new DropFactory(runtimeTypesProvider, false);

        self.data.eventing = util.convertListOfKeyValuesToObject(self.data.eventing);

        self.$canvas = $('<div/>')
            .addClass('boxToBorderSize')
            .attr('name', self.data.name)
            .appendTo(self.$element)
            .attr('tabindex', self.data.tabIndex)
            .css({
                overflow: "scroll",
                position: "relative",
                display: "block",
                verticalAlign: 'middle',
                width: '100%',
                height: '100%'
            });

        self.$element
            .css({
                whiteSpace: 'pre-wrap',
                display: "block"
            });

        //new OnLongPress().applyLongPressOnElement(this.$canvas, this);

        Style.renderStyles(self,null, self.$canvas);

        return self;
    };

    Drop.extend(BusinessProcessCanvas, Drop);

    BusinessProcessCanvas.typeName = 'BusinessProcessCanvas';

    BusinessProcessCanvas.prototype.setValue = function (update) {
        var self = this;
        self.piping.dispatcher.dispatch(
            'LicquidAction/GetDrawing',
            {
                id: update.value
            },
            function (result) {
                self.$canvas.empty();

                var drops = self.drawingDropFactory.createDrops(result.drawing.childDrops);

                _.each(drops, function (drop) {
                    drop.piping = self.piping;
                    drop.render(self.$canvas);
                });

                _.each(drops, function (drop) {
                    businessProcessEvents.informListeners('bp_element_moved_' + drop.data.id, drop);
                });
            }
        );
    };

    BusinessProcessCanvas.prototype.renderStyles = function () {
        Style.renderStyles(this, null, this.$canvas);
    };

    BusinessProcessCanvas.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    var getWidth = function ($canvas, $milestones) {
        var width = 0;

        if ($milestones.length) {
            $milestones
                .each(function () {
                    width += $(this).outerWidth(true);
                });

            return width;
        } else {
            $canvas.children()
                .each(function () {
                    var $element = $(this);
                    if ($element.height()) {
                        var right = $element.position().left + $element.outerWidth();
                        if (right > width) {
                            width = right;
                        }
                    }
                });     
        }

        return width;
    };

    var getHeight = function ($canvas, $milestones) {
        if ($milestones.length)
            return $milestones.height();
        return $canvas.get(0).scrollHeight;
    };

    var getDimensions = function ($canvas) {
        var $milestones = $canvas
            .children('.bp-milestone');

        return {
            width: getWidth($canvas, $milestones),
            height: getHeight($canvas, $milestones)
        };
    }

    BusinessProcessCanvas.prototype.getFile = function () {
        var deferred = when.defer();

        var dimensions = getDimensions(this.$canvas);

        var $copy = this.$canvas
            .clone()
            .css({
                position: 'relative',
                width: dimensions.width + 'px',
                height: dimensions.height + 'px'
            })
            .appendTo($('body'));

        html2canvas($copy.get(0)).then(function (canvas) {
            var image = canvas.toDataURL('image/png');
            deferred.resolve(image);

            $copy.remove();
        });

        return deferred.promise;
    };

    return BusinessProcessCanvas;
});
